import Cookie from '@/utils/localStorage'

const ProductIdKey = 'product_id'
const RecentLoginListKey = `recent_login_list_${getProductId()}` // 最近登录的列表
const CACHE_KEY = '__yuanqi__'

export function getUserInfo() {
  let userInfo = {}
  try {
    userInfo = JSON.parse(Cookie.get(`${CACHE_KEY}_userInfo`)) || {}
  } catch (err) {
    // TODO
  }
  return userInfo
}

export function setUserInfo(data) {
  return Cookie.set(`${CACHE_KEY}_userInfo`, JSON.stringify(data))
}

// 获取产品ID
export function getProductId() {
  return '0'
}

// 设置产品ID
export function setProductId(val) {
  return Cookie.set(ProductIdKey, val, { expires: 365 })
}

// 增加最近的登录历史
export function getRecentLoginList() {
  // eslint-disable-next-line no-mixed-operators
  return Cookie.get(RecentLoginListKey) && JSON.parse(Cookie.get(RecentLoginListKey)) || []
}

function isVip(userInfo) {
  return userInfo && userInfo.vip_type && userInfo.vip_type !== '0'
}

export function addRecentLoginList(userInfo, token) {
  const list = getRecentLoginList()
  if (userInfo && token) {
    userInfo.token = token
    if (isVip(userInfo)) {
      userInfo.is_vip = 1
    }

    let vipIndex = -1
    // 删除相同的账号 & 找到最后一个会员的位置
    list.forEach((item, index) => {
      if (isVip(item)) {
        vipIndex = index
      }
      if (item.open_id === userInfo.open_id) {
        list.splice(index, 1)
      }
    })

    // 最大支持同时保存3个账号。
    // 会员账号登录态高优先级
    // 普通账号登录态保留，按最近退出登录时间，依次保留登录态

    // 判断是否是会员
    if (userInfo.is_vip) {
      list.unshift(userInfo)
    } else {
      vipIndex = vipIndex + 1 >= 2 ? 2 : vipIndex + 1
      list.splice(vipIndex, 0, userInfo)
    }

    saveRecentLoginList(list.slice(0, 3))
  }
}

export function removeRecentLoginList(index) {
  const list = getRecentLoginList()
  if (list) {
    list.splice(index, 1)
    saveRecentLoginList(list)
  }
}

export function saveRecentLoginList(list) {
  Cookie.set(RecentLoginListKey, list, { expires: 365 })
}

export function saveSmsCoolDownTime(timestamp) {
  Cookie.set(`${CACHE_KEY}_sms_cool_down_time`, timestamp, { expires: 365 })
}

export function getSmsCoolDownTime() {
  return Cookie.get(`${CACHE_KEY}_sms_cool_down_time`)
}

export function setRuleTime(timestamp) {
  Cookie.set(`${CACHE_KEY}_yuanbao_rule_time`, timestamp, { expires: 365 })
}

export function getRuleTime() {
  return Cookie.get(`${CACHE_KEY}_yuanbao_rule_time`)
}
